import PropTypes from 'prop-types';
import React from 'react';
import t from '../../lib/I18n';
import Button from 'react-bootstrap/lib/Button';
import connectToStores from '../../helpers/connectToStores';
import BaseModal from './BaseModal';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import DimensionsStore from '../../stores/DimensionsStore';

/**
 * Renders either a complete message or a cropped one and
 * will display the complete message in the modal.
 */
export class CroppedMessage extends React.PureComponent {
    static propTypes = {
        isMobileWidth: PropTypes.bool,
        maxLength: PropTypes.number,
        message: PropTypes.string.isRequired
    };

    static defaultProps = {
        isMobileWidth: false,
        maxLength: 250
    };

    state = {
        showModal: false
    };

    _toggleModal = () => {
        this.setState({
            showModal: !this.state.showModal
        });
    };

    _shouldCrop(message) {
        const { isMobileWidth, maxLength } = this.props;
        return isMobileWidth && message.length > maxLength;
    }

    _adjustedText(shouldCrop, message) {
        const { maxLength } = this.props;

        if (!shouldCrop) {
            return message;
        }

        // crop the text accordingly
        return message.substring(0, maxLength) + ' ... ';
    }

    _renderReadMoreModal() {
        const { message } = this.props;
        const { showModal } = this.state;

        if (!showModal) {
            return null;
        }

        return (
            <BaseModal
              continueText={ 'global.banner.dismiss' }
              titleText={ 'global.banner.readmore' }
              onContinue={ this._toggleModal }
              hideClose>
              <FormattedHTMLMessage
                message={ message } />
            </BaseModal>
        );
    }

    render () {
        const { message } = this.props;
        const shouldCrop = this._shouldCrop(message);
        const text = this._adjustedText(shouldCrop, message);

        return (
            <div>
              { this._renderReadMoreModal() }
              <FormattedHTMLMessage message={ text } />
              { shouldCrop &&
                  <Button
                      className="btn-link"
                      onClick={ this._toggleModal }>
                        { t('global.banner.readmore') }
                  </Button> }
            </div>
        );
    }
}

function getStateFromStores () {
    return {
        isMobileWidth: DimensionsStore.isMobileWidth()
    };
}

export default connectToStores([ DimensionsStore ], getStateFromStores)(CroppedMessage);
